export default __webpack_public_path__ + "static/media/notebook.73f285af.png";